<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Lease term">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="term">Term</label>
              <input type="number" 
              class="form-control" 
              id="term" 
              placeholder="Term"
              v-model="term">
              <div class="invalid-feedback" v-if="errors.term">{{ errors.term[0] }}</div>
            </div>
            <div class="form-group">
                <label for="rvRate">RV rate</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="rvRate" 
                placeholder="RV rate"
                v-model="rvRate">
                <div class="invalid-feedback" v-if="errors.rvRate">{{ errors.rvRate[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as leaseTermService from '../../services/leaseTerm.service';
    export default {
        name:"ModelLeaseTermEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                term:'',
                rvRate:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettLeaseTermAll']),
        },
        methods:{
            ...mapActions(['fetchLeaseTermAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.term = props.rowData.term;
                this.rvRate = props.rowData.rvRate;
            },

            fnUpdate:async function(){
                const obj = {
                    "term":this.term,
                    "rvRate":this.rvRate,
                    "status":this.status
                }

                try{
                    await leaseTermService.update(this.id, obj);
                    this.fetchLeaseTermAll();
                    messageService.fnSweetAlertSuccessToast('Lease term', 'Updated successfully ');
                    this.hideModal();

                    this.id = ''; 
                    this.term = '';
                    this.rvRate = '';
                    this.status ='';
                }catch(error){
                    messageService.fnSweetAlertErrorToast('Lease term - update', error.response.data.message);
                }
            }
        }
    }
</script>